export default "__VITE_ASSET__Du$M3Ukh__"